import { render, staticRenderFns } from "./StorageRegisterDialog.vue?vue&type=template&id=29bbdcf0&scoped=true&"
import script from "./StorageRegisterDialog.vue?vue&type=script&lang=js&"
export * from "./StorageRegisterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bbdcf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
